module.exports = __webpack_public_path__ + "static/media/flash-and-i.fc2a0030.jpg";